import { motion } from 'framer-motion';

const communityStats = [
  { number: "15", text: "Countries", code: "GEO-15" },
  { number: "200+", text: "Developers", code: "DEV-200" },
  { number: "20+", text: "Trainers", code: "EDU-20" },
  { number: "30+", text: "Community Contributors", code: "COM-30" }
];

const CommunityStats = () => {
  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto relative">
      {/* Background decoration */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(99,102,241,0.05),transparent_50%)]" />
      
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="text-center mb-12 relative"
      >
        <div className="inline-block">
          <div className="text-xs font-mono text-indigo-500/60 mb-2 tracking-wider">[SYSTEM::ANALYTICS]</div>
          <h2 className="text-2xl font-bold text-white font-mono tracking-tight">
            Network Status Report
          </h2>
        </div>
      </motion.div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
        {communityStats.map((stat, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            className="relative group h-[180px]"
          >
            <div className="absolute inset-0 bg-slate-800/20 backdrop-blur-sm rounded-lg border border-slate-700/50 
              group-hover:border-indigo-500/30 transition-all duration-300"
            />
            
            <div className="relative h-full p-6 flex flex-col justify-between">
              <div className="flex items-center justify-between">
                <div className="font-mono text-[10px] text-indigo-400/60 tracking-wider">
                  {stat.code}
                </div>
                <div className="flex gap-1">
                  <div className="h-1 w-1 rounded-full bg-indigo-500/30 animate-pulse" />
                  <div className="h-1 w-1 rounded-full bg-indigo-500/20" />
                </div>
              </div>
              
              <div>
                <div className="font-mono text-4xl font-bold text-indigo-400 tracking-tight group-hover:text-indigo-300 transition-colors mb-2">
                  {stat.number}
                </div>
                <div className="text-sm text-slate-400 font-mono group-hover:text-slate-300 transition-colors">
                  {stat.text}
                </div>
              </div>
            </div>
          </motion.div>
        ))}
      </div>

      {/* Decorative bottom text */}
      <div className="mt-4 text-center">
        <div className="text-[10px] font-mono text-indigo-500/40 tracking-wider">
          [END::ANALYTICS_REPORT]
        </div>
      </div>
    </section>
  );
};

export default CommunityStats;